import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../../generic-components/Heading';
import { WIDGET_HEADING_STYLE, WIDGET_TEXT_STYLE } from '../../../styles';
import { ProfilePlanPromotion } from '../../../../../flows/profile/components/ProfilePlanPromotion';
import { ReactComponent as CategorizationLogo } from '../../../../../assets/dashboard/categorization-logo.svg';

const testIdPrefix = 'CategorizationPromotion';

export const CategorizationPromotion = () => {
  const { t } = useTranslation();
  return (
    <div className='relative z-10 mt-[80px]'>
      <CategorizationLogo className='mx-auto w-[156px] scale-110' />
      <Heading title={t('CATEGORIZATION_PROMOTION.TITLE')} className={`${WIDGET_HEADING_STYLE} leading-4 text-center mt-[20px]`} testId={`${testIdPrefix}__title`} />
      <div className={`${WIDGET_TEXT_STYLE} w-[215px] leading-4 text-center mt-[14px]`} data-testid={`${testIdPrefix}__subtitle`}>{t('CATEGORIZATION_PROMOTION.SUBTITLE')}</div>
      <div className={`${WIDGET_TEXT_STYLE} w-[215px] leading-4 text-center mt-[25px] mb-[22px]`} data-testid={`${testIdPrefix}__more-info`}>{t('CATEGORIZATION_PROMOTION.MORE_INFO')}</div>
      <ProfilePlanPromotion
        customTitle={t('CATEGORIZATION_PROMOTION.BTN_TEXT')}
        planType='BASIC_V2'
        shouldAppearAsButton
        testId={`${testIdPrefix}__button`}
        buttonClassName='w-[225px] h-[40px] rounded-[4px] flex items-center mx-auto justify-center self-center border-[1px] border-bw05 font-metricRSemibold text-sm text-action03 hover:text-action04'
      />
    </div>
  );
};
